// Generated by scripts/generateSitemap.ts.
// Contains public SEO fields only for approved, published business profiles.
export const PUBLIC_BUSINESS_PROFILE_SEO_TARGET = {"projectId":"soko-grid","frontendProjectId":"soko-grid","storageBucket":"soko-grid.firebasestorage.app","functionsRegion":"africa-south1"} as const;
export const PUBLIC_BUSINESS_PROFILE_SEO = [
  {
    "slug": "babbles-inflatable",
    "name": "Babbles inflatable",
    "businessName": "Babbles inflatable",
    "shortDescription": "We specialize in hiring and sales of bouncing castle, popcorn and candy floss machines. Also offer Event planning services.",
    "category": "Events & Parties",
    "categoryName": "Events & Parties",
    "subCategoryText": "Bouncing Castle & Popcorn Planet",
    "subcategoryName": "Bouncing Castle & Popcorn Planet",
    "subCategory": [
      "Bouncing Castle & Popcorn Planet"
    ],
    "phone": "+254721905651",
    "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2FkURbtgGT0eBQroddixoE%2Fbrand%2Fprofile-1781165916915.jpg?alt=media&token=204af5ea-4ed6-40fd-8e7e-632ef2c5cccf",
    "countyName": "Kiambu",
    "cityName": "Kikuyu",
    "areaName": "Sigona",
    "location": {
      "countyName": "Kiambu",
      "cityName": "Kikuyu",
      "areaName": "Sigona"
    },
    "businessHours": {
      "timezone": "Africa/Nairobi",
      "sameHoursEveryDay": false,
      "is24Hours": true,
      "temporarilyClosed": false,
      "weekly": {
        "sunday": {
          "isOpen": false
        },
        "monday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "tuesday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "wednesday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "thursday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "friday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "saturday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        }
      }
    }
  },
  {
    "slug": "kluger-properties",
    "name": "Kluger Properties",
    "businessName": "Kluger Properties",
    "shortDescription": "Kluger Properties offers trusted land and plot for sale services in Kikuyu and surrounding areas. We help buyers find suitable residential and investment plots with clear information, reliable guidance, and convenient viewing support. We assist with plot verification, title deed search and property checks.",
    "category": "Real Estate & Property",
    "categoryName": "Real Estate & Property",
    "subCategoryText": "Land & Plots",
    "subcategoryName": "Land & Plots",
    "subCategory": [
      "Land & Plots"
    ],
    "phone": "+254722657678",
    "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2FFibaLxW59kcfU6SiIqkN%2Fbrand%2Fprofile-1780748592207.jpg?alt=media&token=5d7a8a82-8a76-4310-aa22-d2ad1b0378f1",
    "countyName": "Kiambu",
    "cityName": "Kikuyu",
    "areaName": "Sigona",
    "location": {
      "countyName": "Kiambu",
      "cityName": "Kikuyu",
      "areaName": "Sigona"
    },
    "businessHours": {
      "timezone": "Africa/Nairobi",
      "sameHoursEveryDay": false,
      "is24Hours": true,
      "temporarilyClosed": false,
      "weekly": {
        "sunday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "monday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "tuesday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "wednesday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "thursday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "friday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        },
        "saturday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1080
        }
      }
    }
  },
  {
    "slug": "sample-business",
    "name": "Sample Business",
    "businessName": "Sample Business",
    "shortDescription": "We make fresh custom cakes for birthdays, weddings, graduations, baby showers, and special events. We also offer cupcakes, pastries, snacks, and dessert treats.",
    "category": "Food, Drink & Hospitality",
    "categoryName": "Food, Drink & Hospitality",
    "subCategoryText": "Bakeries & Snacks Shops",
    "subcategoryName": "Bakeries & Snacks Shops",
    "subCategory": [
      "Bakeries & Snacks Shops"
    ],
    "phone": "+254722657678",
    "logoUrl": "https://firebasestorage.googleapis.com/v0/b/soko-grid.firebasestorage.app/o/businesses%2Ff1bugXeqFaPQzWhmuOqq%2Fbrand%2Fprofile-1780644116681.jpg?alt=media&token=f338b88d-91d2-4d69-a331-cc90198d430e",
    "addressLine": "D07, 1st Flr, Kluger Plaza, River Rd.",
    "countyName": "Nairobi",
    "cityName": "Nairobi",
    "areaName": "CBD",
    "location": {
      "countyName": "Nairobi",
      "cityName": "Nairobi",
      "areaName": "CBD"
    },
    "locationPin": {
      "lat": -1.1806797,
      "lng": 36.6317044
    },
    "businessHours": {
      "timezone": "Africa/Nairobi",
      "sameHoursEveryDay": true,
      "is24Hours": false,
      "temporarilyClosed": false,
      "weekly": {
        "sunday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        },
        "monday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        },
        "tuesday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        },
        "wednesday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        },
        "thursday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        },
        "friday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        },
        "saturday": {
          "isOpen": true,
          "openMinutes": 480,
          "closeMinutes": 1170
        }
      }
    }
  }
] satisfies Record<string, unknown>[];
export const PUBLIC_BUSINESS_PROFILE_SEO_SHA256 = "4f7a47c6101f0d37cf832232f3aa8213cbf16a545d177bede82003d5b7a8ce3c" as const;
